import React,  {useEffect, useState} from 'react'
import { Autocomplete, ListSubheader, Button, Menu, MenuItem, TextField, InputAdornment, IconButton, Typography } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import TextFieldPaper from "../ui/TextFieldPaper"
import VirtualListbox from '../ui/VirtualListbox'
import useFinancial from "../../hooks/useFinancial"
import { useSection } from '../../context/section'


const StandardKPICategoryList = ['Market Data','High Level Earnings Data','Balance Sheet','Income Statement','Cash Flow'] 

export default function DropdownFinancial({ financialInfo, ticker, type }) {  
  const [SelectedInfo, setSelectedInfo] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);

  const [StandardFinancialKPIs, setStandardFinancialKPIs] = useState([]); 
  const [CompanySpecificKPIs, setCompanySpecificKPIs] = useState([]); 
  const [StandardFinancialCategory, setStandardFinancialCategory] = useState(StandardKPICategoryList);
  const [CompanyLevelCategory, setCompanyLevelCategory] = useState([]);

  const { updateFinancialInfo : handleChange } = useSection()
  const { options,FinanicalKPICategory } = useFinancial(ticker)
  
  const renderOption = (params, option) => (
    <li {...params} style={{paddingLeft:'27px'}}>
        {option.name}
    </li>
  )

  const handleClick = (AnchorEl) => (event) => {
    AnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (category) => {
    setSelectedCategory(category);
    let Tempoptions = []
    if (category !="All"){
      Tempoptions = options.filter(option => option.category==category)
    }
    else{
      Tempoptions = options
    }
    setSelectedInfo(Tempoptions?.find(t => t.value === financialInfo) || null)
    setAnchorEl(null);
    setAnchorEl2(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorEl2(null);
  };

  const renderInput = (params,AnchorEl,Type) => (
    <TextField
          {...params}
          placeholder="Select..."
          label={Type}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                <InputAdornment position="end">
                  <IconButton onClick={handleClick(AnchorEl)} aria-label="filter">
                    <FilterListIcon />
                  </IconButton>
                </InputAdornment>
              </>
            ),
          }}
        />
  )

  const renderGroup = (params) => ([
    <ListSubheader key={params.key} component="div">{params.group}</ListSubheader>,
    params.children,
  ])

  useEffect(()=>{
    setStandardFinancialKPIs(options?.length?options.filter((item)=>StandardKPICategoryList.includes(item.category)).filter(item=>type == "main"?item:item.nowcasting):[]);
    setCompanySpecificKPIs(type !== "main"&&options?.length?options.filter((item)=>!StandardKPICategoryList.includes(item.category)):[]);
    return () => {}
  },[options])
  
  useEffect(()=>{
    setStandardFinancialCategory(['All',...FinanicalKPICategory.filter((item)=>StandardKPICategoryList.includes(item))])
    setCompanyLevelCategory(FinanicalKPICategory.filter((item)=>!StandardKPICategoryList.includes(item)))
    return () => {}
  },[FinanicalKPICategory])

  useEffect(()=>{
    setSelectedInfo(options?.find(t => t.value == financialInfo) || null)
    return () => {}
  },[financialInfo,options])


  return (
    <>
    {selectedCategory?<Typography variant='h4' style={{marginBottom:'1em'}}> Filter by Category: {selectedCategory} </Typography>:<></>}
    <Menu
      id="category-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {StandardFinancialCategory.map((category) => (
        <MenuItem
          key={category}
          selected={category === selectedCategory}
          onClick={() => handleMenuItemClick(category)}
          sx={{
            bgcolor: category === selectedCategory ? 'primary.main' : 'inherit', // Custom background color for selected
            color: category === selectedCategory ? '#dccb03' : 'inherit',         // Custom text color for selected
          }}
        >
          {category}
        </MenuItem>
      ))}
    </Menu>
    <Menu
      id="category-menu"
      anchorEl={anchorEl2}
      open={Boolean(anchorEl2)}
      onClose={handleClose}
    >
      {CompanyLevelCategory.map((category) => (
        <MenuItem
          key={category}
          selected={category === selectedCategory}
          onClick={() => handleMenuItemClick(category)}
          sx={{
            bgcolor: category === selectedCategory ? 'primary.main' : 'inherit', // Custom background color for selected
            color: category === selectedCategory ? '#dccb03' : 'inherit',         // Custom text color for selected
          }}
        >
          {category}
        </MenuItem>
      ))}
    </Menu>
    <div style={{display:'flex'}}>
    <Autocomplete
      options={selectedCategory !="All"? StandardFinancialKPIs.filter(item=> selectedCategory==item.category) : StandardFinancialKPIs || []}
      getOptionLabel={(option) => option.name}
      renderInput={(params)=>renderInput(params,setAnchorEl,'Standard Financial KPIs')}
      disableClearable
      loading={!StandardFinancialKPIs?.length}
      value={StandardFinancialKPIs.includes(SelectedInfo)?SelectedInfo:null}
      onChange={(_,newValue)=>{handleChange(_,newValue, type)}}
      fullWidth
      renderGroup={renderGroup}
      renderOption={renderOption}
      groupBy={(option) => option.category}
      ListboxComponent={VirtualListbox}
      style={{paddingRight: 5}}
    />
    <Autocomplete
      options={selectedCategory !="All"? CompanySpecificKPIs.filter(item=> selectedCategory==item.category) : CompanySpecificKPIs || []}
      getOptionLabel={(option) => option.name}
      renderInput={(params)=>renderInput(params,setAnchorEl2,'Company Specific KPIs')}
      disableClearable
      loading={!StandardFinancialKPIs?.length}
      value={CompanySpecificKPIs.includes(SelectedInfo)?SelectedInfo:null}
      onChange={(_,newValue)=>{handleChange(_,newValue, type)}}
      fullWidth
      renderGroup={renderGroup}
      renderOption={renderOption}
      groupBy={(option) => option.category}
      ListboxComponent={VirtualListbox}
    />
    </div>
    </>
  )
}
